import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class WidgetParameter extends BasicEntity {
code: string;
dataType: string;
description: TranslatedEmb;
label: TranslatedEmb;
mandatory: boolean | null;
widgetCode: string;
}

